import React from 'react';
import { useNavigate } from 'react-router-dom';
import EditRequestsPanel from './EditRequestsPanel';

/**
 * EditRequestsPage
 * 
 * Full-width dedicated page for managing Edit Requests.
 * Located at Team → Edit Requests.
 * Only accessible to Admin/Team Leaders.
 */
const EditRequestsPage = ({ currentUser }) => {
  const navigate = useNavigate();

  // Permission check
  const canAccess = ['admin', 'tax_search_team_leader', 'title_search_team_leader', 'team_leader'].includes(currentUser?.role);
  
  if (!canAccess) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Access Restricted</h3>
          <p className="text-gray-500">You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="edit-requests-page">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            data-testid="back-button"
          >
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Edit Requests</h1>
            <p className="text-sm text-gray-500">Manage edit requests from Order Desk users</p>
          </div>
        </div>
      </div>

      {/* Full Edit Requests Panel */}
      <EditRequestsPanel 
        currentUser={currentUser}
        onViewOrder={(orderId) => {
          // Feb 25, 2026: Edit Request "View order" lands on Summary tab
          // (billing-free) consistent with the rest of the app. TLs/Admins
          // can switch to Fulfillment to action the requested edit.
          navigate(`/orders/${orderId}/summary`);
        }}
        isCompact={false}
      />
    </div>
  );
};

export default EditRequestsPage;
